"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var useMask_1 = require("../../hooks/useMask");
var buttons_1 = require("../buttons");
var Icon_1 = require("../Icon");
var Spinner_1 = require("../Spinner");
var Typography_1 = require("../Typography");
var Field_1 = require("./Field");
var styles_1 = require("./styles");
var TextInputMenu_1 = require("./TextInputMenu");
var tools_1 = require("../../tools");
var Adornment = function (_a) {
    var icon = _a.icon, extra = _a.extra, addon = _a.addon, loading = _a.loading;
    if (loading) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: addon });
    }
    else if (icon) {
        return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: icon, variant: "outline", fill: "base" });
    }
    else if (!icon && !extra && addon) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: addon });
    }
    else if (!icon && !addon && extra) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: styles_1.adornmentClassNames }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: false, size: "base", className: "squid-text-alias-color-text-weakest" }, { children: extra })) })));
    }
    return null;
};
var TextInput = function (_a) {
    var _b;
    var name = _a.name, placeholder = _a.placeholder, addonTitle = _a.addonTitle, addonIcon = _a.addonIcon, _c = _a.addonPosition, addonPosition = _c === void 0 ? 'right' : _c, _d = _a.addonVariant, addonVariant = _d === void 0 ? 'default' : _d, addOnMenu = _a.addOnMenu, onClickAddon = _a.onClickAddon, extra = _a.extra, _e = _a.extraPosition, extraPosition = _e === void 0 ? 'right' : _e, icon = _a.icon, disabled = _a.disabled, _f = _a.editable, editable = _f === void 0 ? true : _f, critical = _a.critical, _g = _a.variant, variant = _g === void 0 ? 'single-line' : _g, numberOfLines = _a.numberOfLines, value = _a.value, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onMenuSelect = _a.onMenuSelect, onEnterPress = _a.onEnterPress, inputProps = _a.inputProps, secured = _a.secured, className = _a.className, forwardedRef = _a.forwardedRef, onOutsideClick = _a.onOutsideClick, testId = _a["data-testid"], loading = _a.loading, _h = _a.sanitize, sanitize = _h === void 0 ? false : _h, active = _a.active, mask = _a.mask, id = _a.id, label = _a.label, labelHidden = _a.labelHidden, combo = _a.combo, _j = _a.type, type = _j === void 0 ? 'text' : _j, ariaLabel = _a["aria-label"], autoComplete = _a.autoComplete;
    var _k = (0, react_1.useState)(addOnMenu && addOnMenu.length > 0 ? addOnMenu[0] : undefined), selectedItem = _k[0], setSelectedItem = _k[1];
    var applyMask = (0, useMask_1.useMask)(mask).applyMask;
    var _l = (0, react_1.useState)(false), pressed = _l[0], setPressed = _l[1];
    var _m = (0, react_1.useState)(active), isActive = _m[0], setIsActive = _m[1];
    var _o = (0, react_1.useState)(false), clicked = _o[0], setClicked = _o[1];
    var _p = (0, react_1.useState)(false), open = _p[0], setOpen = _p[1];
    var fieldRef = (0, react_1.useRef)(null);
    var divRef = (0, react_1.useRef)(null);
    var buttonRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var handler = function (e) {
            if (divRef.current && !divRef.current.contains(e.target)) {
                onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick(e);
                setIsActive(false);
            }
        };
        window.addEventListener('click', handler);
        return function () {
            window.removeEventListener('click', handler);
        };
    }, [divRef]);
    var handleBlur = function () {
        var _a;
        setIsActive(false);
        (_a = fieldRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    var handleFocus = function () {
        var _a;
        (_a = fieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setIsActive(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    };
    (0, react_1.useImperativeHandle)(forwardedRef, function () { return ({
        isFocus: function () { var _a; return (_a = fieldRef.current) === null || _a === void 0 ? void 0 : _a.isFocus(); },
        isClicked: function () { return clicked; },
        focus: handleFocus,
        blur: handleBlur,
        dimensions: function () {
            var _a, _b;
            return ({
                offsetTop: (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop,
                offsetHeight: (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight,
            });
        },
    }); });
    var handleChange = function (event) {
        var unmasked = event.target.value;
        var masked = applyMask(unmasked);
        var sanitizedText = (0, tools_1.sanitizeInputValueString)(masked);
        onChange === null || onChange === void 0 ? void 0 : onChange(sanitize ? sanitizedText || masked : masked, unmasked);
    };
    var handleInputValue = function (v) {
        if (typeof v === 'number') {
            return v;
        }
        return (0, tools_1.deSanitizeInputValueString)(v);
    };
    var handleMousePress = function (event) {
        var _a, _b;
        event.stopPropagation();
        setPressed(event.type === 'mousedown');
        if (event.type === 'mousedown') {
            var isClicked = (((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ||
                ((_b = divRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target))) &&
                !clicked;
            setClicked(isClicked);
        }
    };
    var handleKeyDown = function (event) {
        event.stopPropagation();
        if (event.key === 'Escape') {
            handleBlur();
        }
        else {
            handleFocus();
        }
    };
    var handleKeyUp = function (event) {
        event.stopPropagation();
        if (event.key === 'Enter') {
            onEnterPress === null || onEnterPress === void 0 ? void 0 : onEnterPress();
            handleBlur();
        }
    };
    var handleClickAddon = function (event) {
        event.stopPropagation();
        setOpen(!open);
    };
    var handleKeyDownOnAddon = function (event) {
        event.stopPropagation();
    };
    var handleAddonMenuSelect = function (item) { return function () {
        setOpen(!open);
        setSelectedItem(item);
        onMenuSelect === null || onMenuSelect === void 0 ? void 0 : onMenuSelect(item);
    }; };
    var handleAddonMenuClose = function () {
        setOpen(false);
    };
    var isSingleLine = variant === 'single-line' || numberOfLines === 1;
    var hasLeftAddon = loading || (addonPosition === 'left' && (addonTitle || addonIcon));
    var hasRightAddon = !loading && addonPosition === 'right' && (addonTitle || addonIcon);
    var addon;
    if (loading) {
        addon = (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { color: "primary", size: "base" });
    }
    else if (hasRightAddon || hasLeftAddon) {
        var hasMenu = addOnMenu && addOnMenu.length > 0;
        if (hasMenu) {
            addonIcon = open ? 'ChevronUp' : 'ChevronDown';
        }
        addon = ((0, jsx_runtime_1.jsx)(buttons_1.SimpleButton, { type: "button", variant: hasMenu ? 'outlined' : addonVariant, title: hasMenu ? selectedItem.label : addonTitle, rightIcon: addonIcon, active: (_b = fieldRef.current) === null || _b === void 0 ? void 0 : _b.isFocus(), rightIconSize: "md", className: "squid-text-alias-color-text-weaker", onClick: hasMenu ? handleClickAddon : onClickAddon, forwardedRef: buttonRef, "aria-label": open ? 'Close List' : 'Open List' }));
    }
    var hasLeftExtra = extraPosition === 'left' && extra;
    var hasRightExtra = extraPosition === 'right' && extra;
    var leftPadding = hasLeftAddon || hasLeftExtra ? 'tight' : 'base';
    var rightPadding = hasRightAddon || hasRightExtra ? 'tight' : 'base';
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-relative", ref: containerRef }, { children: [label && ((0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "label", id: "".concat(id, "Label"), htmlFor: id, color: "weakest", className: "mb-2 ".concat(labelHidden ? 'squid-sr-only' : '') }, { children: label }))), (0, jsx_runtime_1.jsxs)("div", __assign({ ref: divRef, tabIndex: 0, onKeyDown: handleKeyDown, onMouseDown: handleMousePress, onMouseUp: handleMousePress, className: (0, classnames_1.default)((0, styles_1.getContainerClass)({
                    disabled: disabled,
                    leftPadding: leftPadding,
                    rightPadding: rightPadding,
                    pressed: pressed,
                    active: isActive || clicked,
                    critical: critical,
                    single: isSingleLine,
                }), className) }, { children: [(icon || hasLeftAddon || hasLeftExtra || loading) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, styles_1.addonClassNames)(isSingleLine), onClick: handleFocus, onKeyDown: handleKeyDownOnAddon }, { children: (0, jsx_runtime_1.jsx)(Adornment, { icon: icon, addon: addon, extra: extra, loading: loading }) }))), (0, jsx_runtime_1.jsx)(Field_1.default, { as: isSingleLine ? 'input' : 'textarea', variant: variant, name: name, id: id, rows: isSingleLine ? undefined : 4, disabled: disabled, value: handleInputValue(value), onChange: editable ? handleChange : undefined, onFocus: !loading ? handleFocus : undefined, onBlur: handleBlur, onKeyUp: handleKeyUp, placeholder: placeholder, forwardedRef: fieldRef, inputProps: __assign(__assign({ type: type }, (inputProps || {})), { readOnly: !editable }), secured: secured, "data-testid": testId, role: combo ? 'combobox' : undefined, "aria-expanded": combo ? open : undefined, "aria-label": ariaLabel, autoComplete: autoComplete }), (hasRightAddon || hasRightExtra) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, styles_1.addonClassNames)(isSingleLine), onKeyDown: handleKeyDownOnAddon }, { children: (0, jsx_runtime_1.jsx)(Adornment, { addon: addon, extra: extra }) })))] })), (0, jsx_runtime_1.jsx)(TextInputMenu_1.TextInputMenu, { open: open, anchorPosition: addonPosition, menus: addOnMenu, value: selectedItem, onClick: handleAddonMenuSelect, onClose: handleAddonMenuClose })] })));
};
exports.TextInput = TextInput;
